<template>
  <div class="main-header">
    <div class="menu-toggle" @click="compactSideBarToggle">
      <div></div>
      <div></div>
      <div></div>
    </div>

    <div style="margin: auto"></div>
    <div class="header-part-right">
      <i
        class="i-Full-Screen header-icon d-none d-sm-inline-block"
        @click="handleFullScreen"
      ></i>
    </div>
  </div>
</template>
<script>
import Util from "@/utils"
import { mapActions, mapGetters } from "vuex"

export default {
  data() {
    return {
      isDisplay: true,
      isStyle: true,
      isSearchOpen: false,
      isMouseOnMegaMenu: true,
      isMegaMenuOpen: false
    }
  },
  computed: {
    ...mapGetters({
      isSideBarOpen: "isOpen"
    })
  },
  methods: {
    ...mapActions([
      "changeCompactSidebarProperties",
      "changeThemeMode",
      "signOut"
    ]),
    logoutUser() {
      this.signOut()
      this.$router.push("/app/sessions/signIn")
    },
    handleFullScreen() {
      Util.toggleFullScreen()
    },
    compactSideBarToggle() {
      this.$store.commit("toggleOpen")
    }
  }
}
</script>
<style scoped>
.offline-status {
  background: red;
  padding: 5px 10px;
  border-radius: 5px;
  color: white;
  font-weight: bold;
}
.pulse {
  box-shadow: 0 0 0 rgba(255, 0, 0, 0.6);
  animation: pulse 2s infinite;
}
@-webkit-keyframes pulse {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(255, 0, 0, 0.6);
  }
  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(255, 0, 0, 0);
  }
  100% {
    -webkit-box-shadow: 0 0 0 0 rgba(255, 0, 0, 0);
  }
}
@keyframes pulse {
  0% {
    -moz-box-shadow: 0 0 0 0 rgba(255, 0, 0, 0.6);
    box-shadow: 0 0 0 0 rgba(255, 0, 0, 0.6);
  }
  70% {
    -moz-box-shadow: 0 0 0 10px rgba(255, 0, 0, 0);
    box-shadow: 0 0 0 10px rgba(255, 0, 0, 0);
  }
  100% {
    -moz-box-shadow: 0 0 0 0 rgba(255, 0, 0, 0);
    box-shadow: 0 0 0 0 rgba(255, 0, 0, 0);
  }
}
</style>
